import { createSelectOption } from '@helpers/utils'

export const BookingOptionStatusesOptions = [
  createSelectOption('Wstępny', 'initial'),
  createSelectOption('Opłacony', 'confirmed'),
  createSelectOption('Wykorzystany', 'used'),
  createSelectOption('Anulowany', 'cancelled'),
]
